import Sentry from '@sentry/browser';
import { FontDto, MusicTrackDto, ThemeDto } from '@wix/video-maker-api';
import toPromise from '../../utils/observableToPromise';
import ErrorNormalizer, { ApiType } from '../ErrorNormalizer';
import { videoMakerApi } from './libWrapper';

import fontsData from './data/fonts';

const assetsErrorNormalizer = new ErrorNormalizer(ApiType.VIDEO_MAKER_ASSETS);

let themes: ThemeDto[];
async function getThemes(): Promise<ThemeDto[]> {
  if (!themes) {
    try {
      themes = await toPromise<ThemeDto[]>(videoMakerApi.getThemes());
    } catch (error) {
      Sentry.captureException(error);
      throw assetsErrorNormalizer.normalizeError(error);
    }
  }

  return themes;
}

let musicTags: string[];
async function getMusicTags(): Promise<string[]> {
  if (!musicTags) {
    try {
      musicTags = await toPromise<string[]>(videoMakerApi.getMusicTags());
    } catch (error) {
      Sentry.captureException(error);
      throw assetsErrorNormalizer.normalizeError(error);
    }
  }

  return musicTags;
}

const musicTracksMap = new Map();
async function getMusicTracks(request: {
  tags?: string[];
  themeId?: string;
}): Promise<{
  noMusicTrackId: string;
  tracks: MusicTrackDto[];
}> {
  const requestKey = JSON.stringify(request);

  if (!musicTracksMap.has(requestKey)) {
    try {
      const { tracks, noMusicTrackId } = await toPromise(
        videoMakerApi.getMusicTracks(request),
      );

      musicTracksMap.set(requestKey, {
        tracks,
        noMusicTrackId: String(noMusicTrackId),
      });
    } catch (error) {
      Sentry.captureException(error);
      throw assetsErrorNormalizer.normalizeError(error);
    }
  }

  return musicTracksMap.get(requestKey);
}

async function getMusicTracksByTag(tag: string) {
  return getMusicTracks({ tags: [tag] });
}

async function getMusicTracksByTheme(themeId: string) {
  return getMusicTracks({ themeId });
}

async function getFonts(): Promise<FontDto[]> {
  return fontsData;
}

export {
  getThemes,
  getMusicTags,
  getMusicTracksByTheme,
  getMusicTracksByTag,
  getFonts,
};
